import styled from 'styled-components'

import { getIsAuthorized } from '../core/AccountProvider'
import navigate from '../core/navigate'
import { useAccountQuery, useNewItemsQuery } from '../core/queries'

import IconButton from '@mui/material/IconButton'
import NotificationsIcon from '@mui/icons-material/Notifications'
import { Badge as UnstyledBadge } from '@mui/material'

const Badge = styled(UnstyledBadge)`
  & .MuiBadge-badge {
    color: white;
    font-size: 11px;
    font-weight: bold;
  }
`

export default () => {
  const isAuthorized = getIsAuthorized()

  const { data: accountData, isLoading: isAccountLoading } = useAccountQuery()

  const { data: newItemsData } = useNewItemsQuery(accountData.lastLoginTime, !isAccountLoading)

  const handleNewItems = () => {
    navigate(
      `/search?isOnSaleOrder=false&sortBy=date_created-desc&timestamp=${new Date(
        accountData.lastLoginTime
      )
        .getTime()
        .toString()
        .substring(0, 10)}&newitems=true`
    )
  }

  return (
    newItemsData.length > 0 &&
    isAuthorized && (
      <IconButton
        id='notifications_new_items'
        color='secondary'
        component='button'
        onClick={handleNewItems}>
        <Badge color='danger' badgeContent={newItemsData.length}>
          <NotificationsIcon sx={{ color: 'purple.main', fontSize: '24px' }} />
        </Badge>
      </IconButton>
    )
  )
}
